import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { Modal, Button } from '@binance-chain/honeycomb'
import { DexThemeProvider } from 'components/common/DexThemeProvider'
import { useI18n } from 'i18n/util'
import { useLocalStorage } from 'hooks/useLocalStorage'

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  p {
    font-size: 14px;
    line-height: 20px;
    color: #1e2026;
    margin-bottom: 12px;
  }
`

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
`

const FullyUnderstand = styled.p`
  font-size: 14px;
  line-height: 16px;
  color: #d0980b;
  white-space: nowrap;
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
`

export const MiniTokenTradeModal = () => {
  const [showMiniTokenWarning, setShowMiniTokenWarning] = useLocalStorage(
    'showMiniTokenWarning',
    undefined
  )

  const initialIsOpen = showMiniTokenWarning === undefined ? true : showMiniTokenWarning

  const [isOpen, setIsOpen] = useState(initialIsOpen)
  const { formatI18nText } = useI18n()

  const close = useCallback(() => {
    setIsOpen(false)
  }, [setIsOpen])

  const saveToLocalstorage = useCallback(() => {
    setIsOpen(false)
    setShowMiniTokenWarning(false)
  }, [setIsOpen, setShowMiniTokenWarning])

  return (
    <DexThemeProvider theme="light">
      <Modal open={isOpen} onClose={close}>
        <Modal.Header title={formatI18nText('exchange.miniToken.warning.title')} onClose={close} />
        <Modal.Content>
          <Content>
            <p>{formatI18nText('exchange.miniToken.warning.content1')}</p>
            <p>{formatI18nText('exchange.miniToken.warning.content2')}</p>
          </Content>
          <ButtonGroup>
            <Button variant="primary" onClick={close}>
              {formatI18nText('exchange.miniToken.warning.button1')}
            </Button>
            <FullyUnderstand onClick={saveToLocalstorage}>
              {formatI18nText('exchange.miniToken.warning.fully.understand')}
            </FullyUnderstand>
          </ButtonGroup>
        </Modal.Content>
      </Modal>
    </DexThemeProvider>
  )
}

export default MiniTokenTradeModal
